import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/fr.ts
var fr_default = {
  "widgets.notifications.fusion-swap-view.status.pending": "En attente",
  "widgets.notifications.fusion-swap-view.status.filled": "Termin\xE9",
  "widgets.notifications.fusion-swap-view.status.false-predicate": "Rempli",
  "widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance": "Rempli",
  "widgets.notifications.fusion-swap-view.status.partially-filled": "Rempli",
  "widgets.notifications.fusion-swap-view.status.wrong-permit": "Rempli",
  "widgets.notifications.fusion-swap-view.status.invalid-signature": "Rempli",
  "widgets.notifications.fusion-swap-view.status.expired": "Expir\xE9",
  "widgets.notifications.fusion-swap-view.status.cancelled": "Annul\xE9",
  "widgets.notifications.fusion-swap-view.control.cancel": "Annuler"
};
export {
  fr_default as default
};
//# sourceMappingURL=fr-HW5JB3YP.js.map
